function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3 2.75H4.5C3.5335 2.75 2.75 3.5335 2.75 4.5V3C2.75 2.86193 2.86193 2.75 3 2.75ZM19.5 21.25H18C18.9665 21.25 19.75 20.4665 19.75 19.5V20.5V21C19.75 21.1381 19.6381 21.25 19.5 21.25ZM4.5 21.25H3C2.86193 21.25 2.75 21.1381 2.75 21V19.5C2.75 20.4665 3.5335 21.25 4.5 21.25Z",
  stroke: "#556677",
  strokeWidth: 1.5
});
var _ref2 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 6.25,
  x2: 11.25,
  y2: 6.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 10.25,
  x2: 11.25,
  y2: 10.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 14.25,
  x2: 16.25,
  y2: 14.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 5.75,
  y1: 18.25,
  x2: 16.25,
  y2: 18.25,
  stroke: "#556677",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 8C22.5 10.4853 20.4853 12.5 18 12.5C15.5147 12.5 13.5 10.4853 13.5 8C13.5 5.51472 15.5147 3.5 18 3.5C20.4853 3.5 22.5 5.51472 22.5 8Z",
  stroke: "#556677"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.213 7.06005C19.213 7.39422 19.0803 7.71471 18.8443 7.951C18.6082 8.1873 18.288 8.32005 17.9541 8.32005C17.6203 8.32005 17.3001 8.1873 17.064 7.951C16.8279 7.71471 16.6953 7.39422 16.6953 7.06005C16.6953 6.72588 16.8279 6.40539 17.064 6.16909C17.3001 5.9328 17.6203 5.80005 17.9541 5.80005C18.288 5.80005 18.6082 5.9328 18.8443 6.16909C19.0803 6.40539 19.213 6.72588 19.213 7.06005Z",
  stroke: "#556677",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16 10.3648C16 9.90535 16.1989 9.46468 16.5531 9.13977C16.9072 8.81486 17.3875 8.63232 17.8882 8.63232",
  stroke: "#556677",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M20.0015 10.3546C20.0015 9.8951 19.8026 9.45443 19.4485 9.12951C19.0944 8.8046 18.6141 8.62207 18.1133 8.62207",
  stroke: "#556677",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgAccountDetailsIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccountDetailsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/account-details-icon.6df4c2b7.svg";
export { ForwardRef as ReactComponent };